import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './FoodScrollAnimation.css';
// import Maggie from '../assets/transparent-maggie.png';
import Maggie from '../assets/AI-maggie.png';


// Images
import ChickenImg from '../assets/ingredients/chicken.png';
import BeansImg from '../assets/ingredients/beans.png';
import BeefImg from '../assets/ingredients/beef-chuncks.png';
import CarrotsImg from '../assets/ingredients/carrots.png';
import BlueberriesImg from '../assets/ingredients/blueberries.png';
import SpinachImg from '../assets/ingredients/spinach.png';
import SalmonImg from '../assets/ingredients/salmon.png';
import EggImg from '../assets/ingredients/egg.png';
import GreenbeansImg from '../assets/ingredients/greenbeans.png';

gsap.registerPlugin(ScrollTrigger);

const FoodScrollAnimation: React.FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const itemRefs = useRef<(HTMLImageElement | null)[]>([]);
  const maggieRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const movementSettings = [
      { x: 200, y: -120, rotation: 50 },
      { x: -180, y: -120, rotation: -45 },
      { x: 250, y: 200, rotation: 60 },
      { x: -210, y: 160, rotation: -40 },
      { x: 150, y: -200, rotation: 90 },
      { x: -260, y: 150, rotation: -75 },
      { x: 180, y: 160, rotation: 120 },
      { x: -140, y: -170, rotation: -90 },
      { x: -160, y: 190, rotation: -60 },
    ];

    const ctx = gsap.context(() => {
      // animating food
      itemRefs.current.forEach((item, index) => {
        if (!item) return;
        const { x, y, rotation } = movementSettings[index];

        gsap.fromTo(
          item,
          { x: 0, y: 0, rotate: 0 },
          {
            x,
            y,
            rotate: rotation,
            scrollTrigger: {
              trigger: containerRef.current!,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
            },
          }
        );
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    if (maggieRef.current) {
      gsap.fromTo(
        maggieRef.current,
        { y: '100%' }, // Start from the bottom of the container
        {
          y: '0%', // Move up (adjust as necessary)
          scrollTrigger: {
            trigger: containerRef.current!,
            start: 'top bottom', // Start when the top of the container reaches the bottom of the viewport
            end: 'center center', // End when the bottom of the container reaches the top of the viewport
            scrub: true,
          },
        }
      );
    }
  }, []);

  const foodImages: string[] = [
    ChickenImg,
    BeansImg,
    BeefImg,
    CarrotsImg,
    BlueberriesImg,
    SpinachImg,
    GreenbeansImg,
    EggImg,
    SalmonImg
  ];

  return (
    <div className="food-scroll-container" ref={containerRef}>
        <img
          src={Maggie}
          alt="Background Maggie"
          className="maggie-overlay"
          ref={maggieRef}
        />
      {foodImages.map((src, index) => (
        <img
          key={index}
          src={src}
          ref={(el: HTMLImageElement | null) => {
            itemRefs.current[index] = el;
          }}
          alt={`food-${index}`}
          className={`food-item food-item-${index + 1}`}
        />
      ))}
    </div>
  );
};

export default FoodScrollAnimation;
